module.exports = __webpack_public_path__ + "media/images/wfc/city-9-3f48fed8dd99bc40cb675bb9f8f8e27c.jpg";